/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description Zappable
 */

export enum Zappable {
  NO = 0,
  MAYBE = 1,
  VERIFIED = 2,
}

Object.defineProperty(Zappable, '__ENUM_NAME', {
  value: 'Zappable',
  writable: false,
  configurable: false,
  enumerable: false,
})
